export const EntityTabs = {
  Accommodation: 0,
  Activities: 1,
  Rental:2
};
